var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dnd-page"},[_c('div',{staticClass:"flex-grid-thirds"},[_c('div',{staticClass:"sml-col"}),_c('div',{staticClass:"col"},[_c('DndCampaignGenerator')],1),_c('div',{staticClass:"sml-col"})])])}
var staticRenderFns = []

export { render, staticRenderFns }